import { CardContent, Card, Grid } from '@material-ui/core'
import { default as React, useState, useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { components, useServices } from 'cng-web-lib'
import CngSelectField from 'src/components/clog/field/CngSelectField'
import CIAApiUrls from 'src/apiUrls/CIAApiUrls'
import CngBackdrop from 'src/components/cngcomponents/CngBackDrop'
import moment from 'moment'

const {
	button: { CngPrimaryButton },
	form: {
		field: { CngDateField }
	}
} = components

function ReportPage(props) {
		const [downloading, setDownloading] = useState(false)
	const [loadingReports, setLoadingReports] = useState(true)
	const { securedSendRequest } = useServices()
	const [reportOptions, setReportOptions] = useState([])

	const methods = useForm({
		defaultValues: { reportId: '', startDate: '', endDate: '' }
	})
	const reportId = methods.watch('reportId')
	const startDate = methods.watch('startDate')
	const endDate = methods.watch('endDate')

		const handleDownload = () => {
		if (!reportId || !startDate || !endDate) return
		setDownloading(true)
		const formattedStart = moment(startDate).format('YYYY-MM-DD')
		const formattedEnd = moment(endDate).format('YYYY-MM-DD')
		securedSendRequest.execute(
			'GET',
			`${CIAApiUrls.DOWNLOAD_PRESET_REPORT}/${reportId}?startDate=${formattedStart}&endDate=${formattedEnd}`,
		{},
					(response) => {
				const { base64Data, fileName } = response.data
				const binaryString = window.atob(base64Data)
				const bytes = new Uint8Array(binaryString.length)
				for (let i = 0; i < binaryString.length; i++) {
					bytes[i] = binaryString.charCodeAt(i)
				}
				const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
				const url = window.URL.createObjectURL(blob)
				const a = document.createElement('a')
				a.href = url
				a.download = fileName || `report_${reportId}.xlsx`
				a.click()
				window.URL.revokeObjectURL(url)
				setDownloading(false)
			},
			(error) => {
				console.error('Download failed', error)
				setDownloading(false)
			},
			() => {}, {}, null
		)
	}
	
	useEffect(() => {
		securedSendRequest.execute(
			'GET',
			CIAApiUrls.GET_AVAILABLE_REPORTS,
			{},
			(response) => {
				const options = Object.entries(response.data).map(([id, name]) => ({ value: id, text: name }))
				setReportOptions(options)
				setLoadingReports(false)
			},
			(error) => {
				console.error('Failed to fetch reports', error)
				setLoadingReports(false)
			},
			() => {}, {}, null
		)
	}, [])

	return (
		<Card>
			<CngBackdrop loading={loadingReports} />
			<CardContent>
				<FormProvider {...methods}>
					<Grid container spacing={2} style={{ marginTop: '8px' }}>
						<Grid item xs={12} sm={6}>
							<CngSelectField
								label='Report Name'
								name='reportId'
								size='small'
								items={reportOptions}
							/>
						</Grid>
						<Grid item xs={false} sm={6} />
						<Grid item xs={12} sm={6}>
							<CngDateField
								label='Start Date'
								name='startDate'
								size='small'
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<CngDateField
								label='End Date'
								name='endDate'
								size='small'
							/>
						</Grid>
						<Grid item xs={12}>
							<CngPrimaryButton
								onClick={handleDownload}
								disabled={!reportId || !startDate || !endDate || downloading}
							>
								{downloading ? 'Downloading...' : 'Download'}
							</CngPrimaryButton>
						</Grid>
					</Grid>
				</FormProvider>
			</CardContent>
		</Card>
	)
}

export default ReportPage